export default "__VITE_ASSET__5DhfS_gK__"